import isLascheScenario from './isLascheScenario';

/**
 * @param {Theme} theme
 * @param {ApiElement} elm
 * @param {ApiElement} nextElm
 * @returns {SpacingType}
 */
const defineSpacing = (theme, elm, nextElm) => {
  if (nextElm) {
    const cmsMap = theme.spacingMap.cms;
    // handle SEPARATOR
    if (elm.type === 'SEPARATOR' || nextElm.type === 'SEPARATOR') {
      return theme.spacingMap.cmsSeparator;
    }
    // handle ANCHOR
    if (elm.type === 'ANCHOR' || elm.type === 'SPECIAL_ELEMENT') {
      return 'spacing0';
    }

    // handle HIGHLIGHT HERO EVP + HEADING
    if (elm.type === 'HERO_STAGE_SINGLE_HIGHLIGHT') {
      return 'spacing500';
    }

    if (elm.type === 'CONTENT_HUB_HERO') {
      return 'spacing500';
    }

    if (isLascheScenario(elm, nextElm)) {
      return theme.spacingMap.containerLarge.negative;
    }

    // handle exceptions if they are defined inside theme.spacingMap.cms
    const elemMap = cmsMap[elm.type];
    const spacing = elemMap && elemMap[nextElm.type];
    if (elemMap && spacing) {
      return spacing;
    }

    // default
    return theme.spacingMap.cmsDefault;
  }

  // last element
  return 'spacing0';
};

export default defineSpacing;
